import React, { useState, useEffect } from 'react';
import './Information.css';
import telegramPhoto from "../../Timer/img.png"

const Succses = ({ message, onClose,state}) => {
    const [visible, setVisible] = useState(true);
    let timer1, timer2;

    useEffect(()=>{
        // const toast = document.querySelector(".toast");
        // const progress = document.querySelector(".progressInf");
        //
        //
        // toast.classList.add("active");
        // progress.classList.add("active");
        //
        // timer1 = setTimeout(() => {
        //     toast.classList.remove("active");
        //
        // }, 5000); //1s = 1000 milliseconds
        //
        // timer2 = setTimeout(() => {
        //     // toast.remove()
        //     setVisible(false)
        //     onClose()
        // }, 5300);


        // closeIcon.addEventListener("click", () => {
        //
        //
        //
        //     clearTimeout(timer1);
        //     clearTimeout(timer2);
        // });

    } , [])
    function handleClickClose(){
        const toast = document.querySelector(".toast");
        const progress = document.querySelector(".progressInf");
        toast.classList.remove("active");
        clearTimeout(timer1)
        clearTimeout(timer2)

        setTimeout(() => {
            progress.classList.remove("active");
            setVisible(false)
            onClose()
        }, 300);
    }

    return (
        <>
            {visible && (


                <div className="toast active">

                    <div className="toast-contentInf">
                        {/*<i style={{color:"#2f2fe5",fontSize:"30px"}} className="fas fa-solid fa-circle-info infor"></i>*/}

                        <div className="message">
                            <span className="text text-1">{message}</span>

                        </div>
                        <div className="tel">
                            <a style={{textAlign:'center'}} target="_blank" href="https://t.me/+khJTTzu2-qc5NTE8"><img className="icoTg" width={40} height={40} src={telegramPhoto} alt=""/></a>

                        </div>
                    </div>

                    {/*<i className="fa-solid fa-xmark close hover_close" onClick={handleClickClose}></i>*/}
                    <div className="progressInf active"></div>
                </div>




            )}
        </>
    );
};

export default Succses;